<template>
  <div class="OrderDetcontent">
    <van-row v-if="orderDetail">
      <van-col span="24" class="cardBar">
        <van-row class="InfoCard">
          <van-col span="24" class="cardNumber">卡号：<span class="number">{{ orderDetail.userCardNumber }}</span></van-col>
          <van-col span="24" class="address">{{orderDetail.address}}</van-col>
          <van-col span="12" class="name">{{orderDetail.userName}}</van-col>
          <van-col span="12" class="area textR">用热面积：{{orderDetail.useArea}}</van-col>
          <van-col span="12" class="money" v-if="orderDetail.status==0">待缴总金额</van-col>
          <van-col span="12" class="money" v-else>已缴总金额</van-col>
          <van-col span="12" class="money textR"><span>¥ {{orderDetail.money}}</span></van-col>
        </van-row>
      </van-col>
      <van-col span="24" >
        <van-row class="billBar" v-for="(itemN,index) in orderDetailList" :key="index" v-if="orderDetailList">
          <van-col span="24" class="title"><i class="icon"></i>{{itemN.createTime}}</van-col>
          <van-col span="24" class="cont">
            <van-col span="14" class="orange bill-money">本采暖季费用：{{itemN.money ? itemN.money : '0'}}元</van-col>
            <van-col span="10" class="bill-money textR">单价：{{itemN.price}}元/m<sup>2</sup> </van-col>
            <van-col span="14">退费金额：{{itemN.refundMoney ? itemN.refundMoney : '0'}}元</van-col>
            <van-col span="10" class="textR">优惠：{{itemN.benefitMoney ? itemN.benefitMoney : '0'}}元</van-col>
          </van-col >
        </van-row>
      </van-col>
      <van-col span="24" type="flex" justify="space-between" class="barBtn">
        <van-button round type="danger" size="large" class="btn" v-if="orderDetail.status==0" @click.prevent="goPayment()">去缴费</van-button>
		<van-button round type="danger" size="large" class="btn" v-if="orderDetail.status==5" @click.prevent="goSearch()">查询状态</van-button>
      </van-col>
    </van-row>
    <van-row  class="noPayBar" v-else>
      <van-col span="24" class="noPayPC"></van-col>
      <van-col span="24" class="text1 orange">没有找到该用户！</van-col>
      <van-col span="24" class="text2">去试试【自主信息填写缴费】吧！</van-col>
    </van-row>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { reqNotpayList,reqPayType,reqPayMethod,reqOrderDetail,reqSearchparam,reqPFSearch,reqPFUpdate} from '../../api'
	export default {
    name:"orderdetail",
	  data(){
	    return{
        orderId:'',
        orderDetailList:[],
        orderDetail:{},
        roomId:'',
        userId:'',
        Method:{},
		roomData:{}
      }
    },
    created(){
      this.orderDetail = this.$cookies.get('orderInfo');
      this.roomId = this.$cookies.get('orderInfo').roomId;
      this.userId = this.$cookies.get('userInfo').userId
    },
    mounted(){
        /*
        * 查询房屋应缴记录
        * */
        let data={
          orderId:this.orderDetail.orderId
        }
        reqOrderDetail(data).then(res => {
          if(res.success){
            this.orderDetailList = res.data
          }else {
            Toast.fail({message:res.msg,className:'apiLoading'});
          }
        })
		this.init();
		
    },
    methods:{
      //帶著roomid跳到roomid繳費頁面
      goPayment(){
        this.$router.push({
          path:'/paydetail',
          name:'paydetail',
          query:{roomId:this.roomId}
        });
      },
	  init(){
		  /*
		   * 查询房屋应缴记录
		   * */
		  reqNotpayList({roomId: this.roomId}).then(res => {
		  	if (res.success) {
		  		this.roomData = res.data
		  		// if (this.isPay) {
		  		// 	this.paymentBtn(this.roomData.canPay)
		  		// }
		  		// //判断是否显示浦发支付
		  		// if(this.roomData.companyId=='D4v1pQBEqaNlLe7wj9Ld9knJgZP5oARy83W'){
		  		// 	this.isPFPay = true
		  		// }
				this.PayType();
		  	} else {
		  		Toast.fail({
		  			message: '系统错误，请联系管理员！',
		  			className: 'apiLoading'
		  		});
		  	}
		  })
	  },
	  /*
	   *  查询支付类型
	   * */
	  PayType() {
	  	let data = {
	  		companyId: this.roomData.companyId,
	  		parentCompanyId: this.roomData.parentCompanyId
	  	}
	  	reqPayType(data).then(res => {
	  		if (res.success) {
	  			this.PayMethod(res.data[0].id)
	  		} else {
	  			Toast.fail({
	  				message: res.msg,
	  				className: 'apiLoading'
	  			});
	  		}
	  	})
	  },
	  /*
	   *  查询支付方法
	   * */
	  PayMethod(payTypeId) {
	  	let data = {
	  		companyId: this.roomData.companyId,
	  		payTypeId: payTypeId
	  	}
	  	reqPayMethod(data).then(res => {
	  		if (res.success) {
	  			this.Method = res.data
	  		} else {
	  			Toast.fail({
	  				message: res.msg,
	  				className: 'apiLoading'
	  			});
	  		}
	  	})
	  },
	  //点击查询事件，获取查询所需参数
	  goSearch(){
		  var params = {orderId:this.orderDetail.orderId,userId:this.userId};
		  reqSearchparam(params).then(res=>{
			  if(res.success){				  
				  var resData = {
					  roomId:res.data.roomId,
					  tranOrdrNo:res.data.tranOrdrNo,
					  tranDate:res.data.tranDate
				  }
				  this.orderSearch(resData);
			  }
		  })
	  },
	  //查询支付情况 res.ordrSt==00 支付成功
	  orderSearch(params){
		  reqPFSearch(params).then(res => {
		  	if (res.ordrSt == "00") {
		  		this.orderUpdate();
		  	} 
		  })
	  },
	  //订单更新
	  orderUpdate() {
	  	//api/wxorder/micropay/update，参数：methodId，orderId，serviceType
	  	var params = {
	  		methodId: this.Method.id,
	  		orderId: this.orderDetail.orderId,
	  		serviceType: this.$cookies.get('service_id'),
	  		roomId:this.roomId
	  	};
	  	reqPFUpdate(params).then(res => {
	  		if (res.success) {
	  			this.$router.go(-1)
	  		}
	  	})
	  },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" >
  @import "../../common/stylus/mixins.styl"
  .OrderDetcontent
    padding 10px 0px
    .orange
      color #ff6d02
    .cardBar
      margin 16px 0px
      padding 24px 24px 40px
      background #fff
      .InfoCard
        background url("./images/bg.png") no-repeat center
        background-size 100% 100%
        padding 48px 30px 20px 40px
        color #fff
        .cardNumber
          line-height 40px
          font-size 38px
          span
            font-size 46px
            font-weight bold
        .name
          padding 15px 0px 40px
          font-size 30px
        .address
          font-size 26px
          padding 30px 0px 15px
        .area
          padding 15px 0px 40px
          font-size 30px
        .money
          line-height 40px
          border-top 2px dashed #fff /*no*/
          padding 27px 0px 20px
          font-size 28px
          span
            font-size 46px
            font-weight bold
    .billBar
      padding 0px 54px 40px 50px
      background #fff
      margin 7px 0px
      .title
        font-size 26px
        color #999999
        padding 42px 0px 36px
        border-bottom 2px solid #f0f0f0
        .icon
          display inline-flex
          width 22px
          height 22px
          margin-right 12px
          background url("./images/time_icon.png") no-repeat center
          background-size 100% 100%
      .cont
        font-size 28px
        color #888888
        .bill-money
          padding 34px 0px
    .barBtn
      padding 15% 40px 0px
      .btn
        color #ffffff
        font-size 32px
        background #ff6d02
        height 88px
        line-height 88px
    .noPayBar
      margin 10px 0px
      height 626px
      background #ffffff
      text-align center
      .noPayPC
        height 50%
        margin-top 15%
        background url("./images/unfound_5.png") no-repeat center
        background-size 50% auto
      .text1
        font-size 32px
        padding 20px 0px
      .text2
        font-size 24px
        color #aaaaaa
    .PayPop
      padding 70px 32px
      .money
        text-align center
        font-size 24px
        color #999999
        span
          display inline-flex
          font-size 80px
          padding 32px 0px
      .Ptext1
        height 80px
        line-height 80px
        font-size 32px
        color #222222
        border-bottom 1px solid #f0f0f0
      .Ptext2
        height 80px
        line-height 80px
        font-size 30px
        color #888888
        border-bottom 1px solid #f0f0f0
      .barBtn
        margin-top 100px
        padding 0px 40px
</style>



// WEBPACK FOOTER //
// src/pages/Order/OrderDetail.vue